import React, { useEffect, useState } from "react";

const TeamV1 = () => {
  const [bannerBottom, setBannerBottom] = useState(null);
  const [loading, setLoading] = useState(true);

  const normalizeStatus = (value) => {
    if (
      value === "active" ||
      value === 1 ||
      value === "1" ||
      value === true ||
      value === "true"
    ) {
      return "active";
    }
    return "inactive";
  };

  useEffect(() => {
    const fetchBannerBottomData = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/banner-bottom-details?id=1"
        );
        const result = await response.json();

        if (result?.status && result?.data) {
          setBannerBottom(result.data);
        }
      } catch (error) {
        console.error("Banner bottom API fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBannerBottomData();
  }, []);

  if (loading) {
    return (
      <section
        className="cta-section"
        style={{
          padding: "50px 0",
          textAlign: "center",
        }}
      >
        <div className="auto-container">
          <p>Loading...</p>
        </div>
      </section>
    );
  }

  if (!bannerBottom) {
    return null;
  }

  const currentStatus = normalizeStatus(
    bannerBottom?.status ??
      bannerBottom?.is_active ??
      bannerBottom?.banner_status ??
      "inactive"
  );

  if (currentStatus === "inactive") {
    return null;
  }

  const backgroundImageUrl = Array.isArray(bannerBottom?.background_image)
    ? bannerBottom?.background_image[0]
    : bannerBottom?.background_image;

  return (
    <>
      <section
        className="cta-section"
        style={{
          position: "relative",
          padding: "50px 0",
          backgroundImage: `url(${backgroundImageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1,
          }}
        ></div>

        <div
          className="auto-container"
          style={{ position: "relative", zIndex: 2 }}
        >
          <h2
            style={{
              fontSize: "42px",
              fontWeight: "600",
              marginBottom: "20px",
              color: "#ffffff",
            }}
          >
            {bannerBottom?.main_heading}
          </h2>

          <p
            style={{
              maxWidth: "850px",
              margin: "0 auto 30px",
              fontSize: "18px",
              lineHeight: "1.6",
              opacity: "0.9",
              color: "#ffffff",
            }}
          >
            {bannerBottom?.main_description}
          </p>

          <a
            href={bannerBottom?.button_link}
            className="theme-btn"
            style={{
              backgroundColor: "#b21e35",
              color: "#fff",
              padding: "12px 40px",
              borderRadius: "0px",
              display: "inline-block",
              textDecoration: "none",
              fontSize: "16px",
              fontWeight: "600",
              transition: "all 0.3s",
            }}
          >
            {bannerBottom?.button_text}
          </a>
        </div>
      </section>
    </>
  );
};

export default TeamV1;